'use strict';

module.exports = {
    SUCCESS: 'success',
    ERROR: 'error',
};
